<template>
  <div class="direct-pkg-wrap">
    <div v-if="adCount.length > 0">
      <div class="card-header">
        定向包 <span class="num-text">{{ dataList.length }}/10</span>
        <div class="btn-group">
          <el-button icon="el-icon-plus" type="text" @click="newDirectPkg">新增</el-button><span class="center-line"></span>
        </div>
      </div>
      <div class="card-list">
        <card-item
          v-for="item of dataList"
          :key="item.itemId"
          :dataSet="item"
          :title="item.targetingName"
          @edit="editItemPkg"
          @copy="copyItemPkg"
          @del="delItemPkg"
          :isCur="curEditId === item.itemId"
          :showDelete="dataList.length > 1"
        >
          {{ item.targetingName }}</card-item
        >
      </div>

      <new-direct-pkg ref="newDirectRef" @changeTargetingName="changeTargetingName"></new-direct-pkg>
    </div>
    <div v-else>
      <div class="card-header">
        定向包
      </div>
      <div class="empty-content">
        请先选账户
      </div>
    </div>
  </div>
</template>

<script>
import CardItem from "./common/cardItem.vue";
import NewDirectPkg from "./subDirectpkg/newDirectPkg.vue";
import { mapState } from "vuex";
import { ageList } from "./common/config";
import Vue from "vue";
export default {
  components: {
    CardItem,
    NewDirectPkg,
  },
  data() {
    return {
      ageList,
      tableConf: [
        { title: "定向包名称", colName: "targetingName" },
        { title: "创建日期", colName: "date" },
      ],
      tableData: [],
      dataList: [],
      curEditId: "", //当前编辑的数据id
    };
  },
  mounted() {
    this.newDirectPkg();
  },
  methods: {
    //编辑定向包
    editItemPkg(dataItem) {
      if (dataItem.itemId === this.curEditId) {
        return;
      } else {
        //编辑切换时只保存到itemcard， 新增复制删除时需要保存到store触发计算（最终的保存在点击预览是校验格式并保存）
        this.saveInItemcard(); //保存当前数据到itemcard后再切换
        this.curEditId = dataItem.itemId;
        this.$nextTick(() => {
          this.$refs.newDirectRef?.fillData(dataItem);
        });
      }
    },
    copyItemPkg(dataItem) {
      if (this.dataList.length >= 10) {
        return;
      }
      this.saveInItemcard();
      let copyData = JSON.parse(
        //先保存数据后取最新数据
        JSON.stringify(this.dataList.find((item) => item.itemId === dataItem.itemId))
      );
      copyData.itemId = Math.random();
      copyData.targetingName = copyData.targetingName + "_复制";
      this.dataList.push(copyData);
      this.saveInStore();
    },
    delItemPkg(dataItem) {
      let curIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(curIndex, 1);
      this.saveInStore();
    },
    //新建定向包
    newDirectPkg() {
      if (this.dataList.length >= 10) {
        return;
      }
      let newItem = {
        itemId: Math.random(),
        districtMode: "UNLIMIT",
        geoLocations: {
          locationTypes: ["LIVE_IN"],
          regions: [],
          transFormRegions: [],
        },
        gender: "GENDER_UNLIMITED",
        ageMode: "UNLIMIT",
        userOsMode: "UNLIMIT",
        userOs: [],
        age: {
          min: 14,
          max: 65,
        },
        appInstallStatus: "UNLIMIT",
        // OPTIMIZATIONGOAL_NONE
        excludedConvertedAudience: {
          excludedDimension: "UNLIMIT",
          conversionBehaviorList: "",
        },
        isCustomTransAction: true,
        networkType: [],
        wxReMarketingMode: [],
        wechatAdBehavior: {
          actions: [],
          excludedActions: [],
        },
        targetingName: "新建定向包" + (this.dataList.length + 1),
      };
      this.dataList.push(newItem);
      this.editItemPkg(newItem);
      //清除自定义媒体包已选数据
      this.$refs.newDirectRef?.clearCustomMediaList();
      this.saveInStore();
    },
    changeTargetingName(data) {
      this.saveInItemcard(); //保存当前数据到itemcard后再切换
      this.$refs.newDirectRef?.fillData(data);
    },
    saveInItemcard() {
      let editData = this.$refs.newDirectRef?.formatData();
      let curIndex = this.dataList.findIndex((item) => item.itemId === this.curEditId);
      if (curIndex !== -1) {
        editData.itemId = this.curEditId;
        Vue.set(this.dataList, curIndex, editData);
      }
    },
    //保存模板时不校验，直接保存
    saveData() {
      this.saveInItemcard(); //保存当前数据后再保存到store
      this.saveInStore();
    },
    saveInStore() {
      let copyData = JSON.parse(JSON.stringify(this.dataList));
      copyData.map((item) => {
        const {
          geoLocations,
          districtMode,
          ageMode,
          gender,
          userOsMode,
          userOs,
          isCustomTransAction,
          appInstallStatus,
          networkType,
          wxReMarketingMode,
          wechatAdBehavior,
        } = item;
        //地区
        item.geoLocations = districtMode === "UNLIMIT" ? null : geoLocations;
        if (ageMode === "UNLIMIT") {
          item.age = null;
        } else if (ageMode !== "CUSTOM") {
          const findObj = this.ageList.find((item) => item.value === ageMode);
          item.age.min = findObj.min;
          item.age.max = findObj.max;
        }
        item.gender = gender === "GENDER_UNLIMITED" ? null : gender;
        item.userOs = userOsMode === "UNLIMIT" ? null : userOs;
        item.appInstallStatus = appInstallStatus === "UNLIMIT" ? null : appInstallStatus;

        if (item.excludedConvertedAudience.excludedDimension === "UNLIMIT") {
          item.excludedConvertedAudience = null;
        } else {
          item.excludedConvertedAudience.conversionBehaviorList = isCustomTransAction
            ? [item.excludedConvertedAudience.conversionBehaviorList]
            : null;
        }
        item.networkType = !networkType || networkType?.length === 0 ? null : networkType;
        if (wxReMarketingMode?.length === 0) {
          item.wxReMarketingMode = ["UNLIMIT"];
          item.wechatAdBehavior = null;
        } else {
          item.wxReMarketingMode = wxReMarketingMode;
          item.wechatAdBehavior = wechatAdBehavior;
        }
        return item;
      });
      this.$store.commit("set_draft_targeting_gdt", copyData);
    },
    checkData() {
      this.$refs.newDirectRef.checkData();
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];
            const conversionBehaviorListFlag =
              item.excludedConvertedAudience.excludedDimension !== "UNLIMIT" &&
              item.isCustomTransAction &&
              !item.excludedConvertedAudience.conversionBehaviorList;
            if (
              conversionBehaviorListFlag ||
              (item.districtMode === "CITY" &&
                (item.geoLocations.locationTypes.length === 0 || item.geoLocations.transFormRegions.length === 0))
            ) {
              pass = false;
              this.editItemPkg(item);
              break;
            }
          }
          if (pass) {
            this.saveData();
            resolve();
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount || [],
      checkedApp: (state) => state.PromotionGdt.checkedApp,
      targeting: (state) => state.PromotionGdt.draft_targeting,
      draftAdset: (state) => state.PromotionGdt.draft_adset,
    }),
  },
  watch: {
    "draftAdset.placementType": {
      handler() {
        this.dataList.map((item) => {
          (item.districtMode = "UNLIMIT"),
            (item.geoLocations = {
              locationTypes: ["LIVE_IN"],
              regions: [],
              transFormRegions: [],
            }),
            (item.gender = "GENDER_UNLIMITED"),
            (item.ageMode = "UNLIMIT"),
            (item.userOsMode = "UNLIMIT"),
            (item.userOs = []),
            (item.age = {
              min: 14,
              max: 65,
            }),
            (item.appInstallStatus = "UNLIMIT"),
            // OPTIMIZATIONGOAL_NONE
            (item.excludedConvertedAudience = {
              excludedDimension: "UNLIMIT",
              conversionBehaviorList: "",
            }),
            (item.isCustomTransAction = true),
            (item.networkType = []),
            (item.wxReMarketingMode = []),
            (item.wechatAdBehavior = {
              actions: [],
              excludedActions: [],
            });
          return item;
        });
      },
    },
    targeting: {
      handler(value) {
        if (value) {
          this.dataList = JSON.parse(JSON.stringify(value));
          this.dataList.map((item) => {
            item.itemId = Math.random();
            if (item.excludedConvertedAudience === null) {
              item.excludedConvertedAudience = {
                excludedDimension: "UNLIMIT",
              };
            } else {
              item.excludedConvertedAudience.conversionBehaviorList = item.excludedConvertedAudience.conversionBehaviorList[0];
            }
            if (item.userOs === null || item.userOs?.length === 0) {
              item.userOsMode = "UNLIMIT";
              item.userOs = [];
            } else {
              item.userOsMode = "CUSTOM";
            }
            item.wxReMarketingMode = item.wxReMarketingMode[0] === "UNLIMIT" ? [] : item.wxReMarketingMode;
            return item;
          });
          //聚焦最后一个
          if (value.length > 0) {
            this.editItemPkg(this.dataList[value.length - 1]);
          }
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.direct-pkg-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
    .btn-group {
      margin-left: auto;
      .center-line {
        border-left: 1px solid rgba(0, 0, 0, 0.25);
        margin: 0 20px;
      }
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
  .empty-content {
    height: 200px;
    font-size: 20px;
    margin-left: 10px;
    color: #818181;
    text-align: center;
    line-height: 200px;
  }
  .drawer-wrap {
    /deep/.el-drawer__header {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.95);
      font-weight: bold;
      margin-bottom: 22px;
    }
  }
}
</style>
